<span class="divider-container" [ngClass]="{'divider-horizon':isHorizon(),'divider-vertical':!isHorizon()}">
    <span class="divider-line"></span>
</span>